import React from 'react'
import { FieldLabel } from '../form/index'
import DebtorSearchSelect from './DebtorSearchSelect'

const DebtorSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={DebtorSearchSelect} />
)

export default DebtorSearchSelectField
